import useClientContext from "../../../context/useClientContext";
import { pageRoutes } from "../../../routes";
import NewObjectDetailsPage from "../../entityFields/grid/NewObjectDetailsPage";
import { checklistsPageTabs } from "../checklists/checklistsPageTabs";

const NewChecklistTaskTemplatePage = () => {
  const { clientCode } = useClientContext();
  const backButtonPath = `/${clientCode}/${pageRoutes.workflows}/${pageRoutes.checklists}?tab=${checklistsPageTabs.taskTemplates}`;

  return <NewObjectDetailsPage objectType="ChecklistTaskTemplate" backButtonPath={backButtonPath} />;
};

export default NewChecklistTaskTemplatePage;
